<iframe sandbox="allow-same-origin allow-scripts allow-popups allow-forms"
    src="https://affectedarc07.github.io/SS13WebMap/TauCetiClassic/BoxStation/"></iframe>